import { DEFAULT_TENANT_TIMEZONE } from "./tenantDateTime";

export function formatCommunicationPublishedAtJa(value: string | null, timeZone = DEFAULT_TENANT_TIMEZONE): string {
  if (!value) {
    return "未設定";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "未設定";
  }

  const parts = new Intl.DateTimeFormat("ja-JP", {
    timeZone,
    month: "numeric",
    day: "numeric",
    weekday: "short",
    hour: "numeric",
    minute: "2-digit",
    hourCycle: "h23"
  }).formatToParts(date);
  const month = parts.find((part) => part.type === "month")?.value ?? "";
  const day = parts.find((part) => part.type === "day")?.value ?? "";
  const weekday = parts.find((part) => part.type === "weekday")?.value ?? "";
  const hour = parts.find((part) => part.type === "hour")?.value ?? "";
  const minute = parts.find((part) => part.type === "minute")?.value ?? "";

  if (!month || !day || !weekday || !hour || !minute) {
    return "未設定";
  }

  return `${month}月${day}日（${weekday}）${hour}時${minute}分`;
}

export function formatMediaDuration(durationSeconds: number | null): string | null {
  if (durationSeconds === null || durationSeconds <= 0 || !Number.isFinite(durationSeconds)) {
    return null;
  }

  const totalSeconds = Math.round(durationSeconds);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}:${String(remainingMinutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  }

  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

export const formatCommunicationVideoDuration = formatMediaDuration;
